import { Expose } from "class-transformer";
import { IsString, IsArray } from "class-validator";

export class InformationAboutBankAccount {
  @IsArray()
  @Expose()
  assignetToOfficePropfileGroup!: Array<Information>;
  @IsArray()
  @Expose()
  assignetToContractorGroup!: Array<Information>;
}

export class Information {
  @IsString()
  @Expose()
  value!: string;
}
